import { render, staticRenderFns } from "./compile.vue?vue&type=template&id=f1364fb0&scoped=true"
import script from "./compile.vue?vue&type=script&lang=js"
export * from "./compile.vue?vue&type=script&lang=js"
import style0 from "./compile.vue?vue&type=style&index=0&id=f1364fb0&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1364fb0",
  null
  
)

export default component.exports